/** The harness's claim refusals that mean "stop asking" (`orion-harness-poc/src/endpoints/credit-miner.ts`). Import-free:
 *  the client branches on them and the server relay passes on only these. */
export const CREDIT_MINER_CLAIM_ERRORS: readonly string[] = ['already_settled', 'missing_conversation_or_amount'];
